import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import promise from 'redux-promise';
import reducers from './redux/reducers/index';

const middleWares = process.env.NODE_ENV === 'development' ? compose(applyMiddleware(reduxThunk, promise), window.devToolsExtension ? window.devToolsExtension() : f => f) : applyMiddleware(reduxThunk, promise);

const store = createStore(reducers, middleWares);

export { store };
export default store;



// WEBPACK FOOTER //
// ./src/store.js